import DevModal from './DevModal';

export default DevModal;
